export const LOGIN_USER_INFO = 'LOGIN_USER_INFO'
// 验证码TOKEN KEY
export const CAPTCHA_TOKEN = 'c_t'